import { getFormattedTimeInEST } from '@zorba-shared/core/Services/textService';

export const getTableColumns = () => [
  {
    title: 'Address',
    key: 'address',
    render: ({ address }) => address,
  },
  {
    title: 'City',
    key: 'city',
    render: ({ city }) => city,
  },
  {
    title: 'State',
    key: 'state',
    render: ({ state }) => state,
  },
  {
    title: 'ZIP',
    key: 'zip',
    render: ({ zip }) => zip,
  },
  {
    title: 'Last sale date',
    key: 'lastSaleDate',
    render: ({ last_sale_date }) => getFormattedTimeInEST(last_sale_date),
  },
  {
    title: 'Owner name 1',
    key: 'ownerName1',
    render: ({ owner_name_1 }) => owner_name_1,
  },
  {
    title: 'Owner name 2',
    key: 'ownerName2',
    render: ({ owner_name_2 }) => owner_name_2,
  },
  {
    title: 'Owner name 3',
    key: 'ownerName3',
    render: ({ owner_name_3 }) => owner_name_3,
  },
  {
    title: 'Owner name 4',
    key: 'ownerName4',
    render: ({ owner_name_4 }) => owner_name_4,
  },
  {
    title: 'Owner name 5',
    key: 'ownerName5',
    render: ({ owner_name_5 }) => owner_name_5,
  },
  {
    title: 'Mailing Address',
    key: 'mailingAddress',
    render: ({ mailing_address }) => mailing_address,
  },
  {
    title: 'Mailing City',
    key: 'mailingCity',
    render: ({ mailing_city }) => mailing_city,
  },
  {
    title: 'Mailing State',
    key: 'mailingState',
    render: ({ mailing_state }) => mailing_state,
  },
  {
    title: 'ZIP',
    key: 'mailingZip',
    render: ({ mailing_zip }) => mailing_zip,
  },
];
